import {ColorBet} from "../betTypes/ColorBet";
import {ColumnBet} from "../betTypes/ColumnBet";
import {CornerBet} from "../betTypes/CornerBet";
import {DozenBet} from "../betTypes/DozenBet";
import {EvenOddBet} from "../betTypes/EvenOddBet";
import {LineBet} from "../betTypes/LineBet";
import {LowHighNumbersBet} from "../betTypes/LowHighNumbersBet";
import {SplitBet} from "../betTypes/SplitBet";
import {StraightBet} from "../betTypes/StraightBet";
import {StreetBet} from "../betTypes/StreetBet";

export class RouletteBets {
    public colorBets: Array<ColorBet> = [];
    public columnBets: Array<ColumnBet> = [];
    public cornerBets: Array<CornerBet> = [];
    public dozenBets: Array<DozenBet> = [];
    public evenOddBets: Array<EvenOddBet> = [];
    public lineBets: Array<LineBet> = [];
    public lowHighNumbersBets: Array<LowHighNumbersBet> = [];
    public splitBets: Array<SplitBet> = [];
    public straightBets: Array<StraightBet> = [];
    public streetBets: Array<StreetBet> = [];
}



// WEBPACK FOOTER //
// ./src/app/api/RouletteBetsProtocol.ts